(() => {
  const root = document.getElementById('flock-store-camera');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const assembly = root.querySelector('.fc-camera');
  const head = root.querySelector('.fc-head');
  const space = root.querySelector('.fc-camera-space');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const pageWrapper = document.querySelector('.page-wrapper');
  const wrapperScroll = window.matchMedia('(min-width: 990px)');
  const scrollPosition = () => pageWrapper && wrapperScroll.matches ? pageWrapper.scrollTop : window.scrollY;
  const isHome = root.dataset.home === 'true';
  let hero = isHome ? document.querySelector('#MainContent .hero') : null;
  let pointer = null;
  let progress = isHome && hero ? 0 : 1;
  let yaw = -28;
  let pitch = -12;
  let frame = 0;
  let lastScroll = scrollPosition();
  let mobileAim = null;
  let mobileDirection = 1;
  let sections = [];
  let active = true;
  let metrics;
  const clamp = (value, low, high) => Math.max(low, Math.min(high, value));
  function updateMobileAttention() {
    if (finePointer.matches || reduced.matches) { mobileAim = null; return; }
    const gazeLine = metrics.height * .42;
    let attention = null;
    let best = Infinity;
    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      if (!rect.width || rect.bottom <= 0 || rect.top >= metrics.height) continue;
      const distance = rect.top <= gazeLine && rect.bottom >= gazeLine ? 0 : Math.min(Math.abs(rect.top - gazeLine), Math.abs(rect.bottom - gazeLine));
      if (distance < best) { best = distance; attention = section; }
    }
    if (!attention) attention = hero;
    if (!attention) {
      mobileAim = { x: metrics.width * .4, y: metrics.height * (mobileDirection < 0 ? .3 : .6) };
      return;
    }
    const heading = attention.querySelector('h1, h2, h3, .h1, .h2, .h3');
    const rect = (heading || attention).getBoundingClientRect();
    mobileAim = {
      x: clamp(rect.left + rect.width * .5, 24, metrics.width - 24),
      y: clamp(rect.top + rect.height * .5 + (mobileDirection < 0 ? -85 : 45), metrics.headerBottom + 30, metrics.height * .72)
    };
  }
  function measure() {
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight;
    const mobile = width < 750;
    const header = document.getElementById('header-component');
    const headerRect = header?.getBoundingClientRect();
    const headerBottom = headerRect ? Math.max(0, headerRect.bottom) : 0;
    if (hero) hero.setAttribute('data-flock-camera-hero', '');
    const heroRect = hero?.getBoundingClientRect();
    const heroTop = heroRect ? heroRect.top + scrollPosition() : 0;
    const heroHeight = heroRect ? heroRect.height : 0;
    const settleDistance = Math.max(280, heroTop + heroHeight - headerBottom);
    metrics = { width, height, mobile, headerBottom, heroTop, heroHeight, settleDistance };
    sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
    updateMobileAttention();
  }
  function draw() {
    frame = 0;
    if (!active || document.hidden) return;
    const scroll = scrollPosition();
    const targetProgress = hero && !reduced.matches ? clamp(scroll / metrics.settleDistance, 0, 1) : 1;
    const smooth = reduced.matches ? 1 : .095;
    progress += (targetProgress - progress) * smooth;
    const header = document.getElementById('header-component');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const headerFloor = Math.max(16, Math.min(metrics.mobile ? 110 : 160, headerBottom + 20));
    const startX = metrics.mobile ? metrics.width - 100 : metrics.width * .79;
    const heroY = metrics.mobile
      ? metrics.heroTop + 70 - scroll
      : metrics.heroTop + Math.min(metrics.heroHeight * .39, 240) - scroll;
    const startY = Math.max(headerFloor + 32, heroY);
    const endX = metrics.width - (metrics.mobile ? 48 : 72);
    const endY = headerFloor + (metrics.mobile ? 28 : 45);
    const cx = startX + (endX - startX) * progress;
    const cy = startY + (endY - startY) * progress;
    const startScale = metrics.mobile ? .62 : clamp(metrics.width / 1100, .95, 1.35);
    const endScale = metrics.mobile ? .36 : .42;
    const scale = startScale + (endScale - startScale) * progress;
    let targetYaw = finePointer.matches ? 0 : -28 + 12 * progress;
    let targetPitch = finePointer.matches ? 0 : -12 + 8 * progress;
    if (pointer && finePointer.matches && !reduced.matches) {
      const dx = pointer.x - cx;
      const dy = pointer.y - cy;
      targetYaw = clamp(Math.atan2(dx, 340) * 180 / Math.PI, -60, 60);
      targetPitch = clamp(-Math.atan2(dy, Math.hypot(dx, 340)) * 180 / Math.PI, -35, 35);
    } else if (mobileAim && !finePointer.matches && !reduced.matches) {
      const dx = mobileAim.x - cx;
      const dy = mobileAim.y - cy;
      targetYaw = clamp(Math.atan2(dx, 290) * 180 / Math.PI, -50, 50);
      targetPitch = clamp(-Math.atan2(dy, Math.hypot(dx, 290)) * 180 / Math.PI, -42, 28);
    }
    yaw += (targetYaw - yaw) * smooth;
    pitch += (targetPitch - pitch) * smooth;
    assembly.style.left = `${cx}px`;
    assembly.style.top = `${cy}px`;
    assembly.style.transform = `translate(-50%,-50%) scale(${scale})`;
    space.style.perspectiveOrigin = `${cx}px ${cy}px`;
    head.style.transform = `rotateX(${pitch}deg) rotateY(${yaw}deg)`;
    root.dataset.ready = 'true';
    if (Math.abs(targetProgress - progress) > .001 || Math.abs(targetYaw - yaw) > .02 || Math.abs(targetPitch - pitch) > .02) schedule();
  }
  function schedule() {
    if (!frame && active && !document.hidden) frame = requestAnimationFrame(draw);
  }
  document.addEventListener('pointermove', (event) => {
    if (!finePointer.matches || reduced.matches || event.pointerType === 'touch') return;
    pointer = { x: event.clientX, y: event.clientY };
    schedule();
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (!event.relatedTarget) { pointer = null; schedule(); }
  }, { passive: true });
  window.addEventListener('blur', () => { pointer = null; schedule(); });
  function onScroll() {
    const scroll = scrollPosition();
    if (scroll !== lastScroll) mobileDirection = scroll < lastScroll ? -1 : 1;
    lastScroll = scroll;
    updateMobileAttention();
    schedule();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  wrapperScroll.addEventListener('change', () => { lastScroll = scrollPosition(); measure(); schedule(); });
  window.addEventListener('resize', () => { measure(); schedule(); }, { passive: true });
  reduced.addEventListener('change', () => { pointer = null; updateMobileAttention(); schedule(); });
  finePointer.addEventListener('change', () => { pointer = null; updateMobileAttention(); schedule(); });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pagehide', () => {
    active = false;
    cancelAnimationFrame(frame);
    frame = 0;
  });
  window.addEventListener('pageshow', () => { active = true; measure(); schedule(); });
  document.addEventListener('shopify:section:load', () => {
    hero = isHome ? document.querySelector('#MainContent .hero') : null;
    measure();
    schedule();
  });
  const observer = new ResizeObserver(() => { measure(); schedule(); });
  if (hero) observer.observe(hero);
  const header = document.getElementById('header-component');
  if (header) observer.observe(header);
  measure();
  schedule();
})();
